/* globals sift */
angular.module('zc.zenclerkS')

  .component('zcsDashboardMain', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/dashboard-main.html',
    bindings: {
      project: '<',
    },
    controller: zcsDashboardMainController
  });

zcsDashboardMainController.$inject = ['$compile', '$element', '$location', '$scope', 'Campaign'];
function zcsDashboardMainController($compile, $element, $location, $scope, Campaign) {
  const vm = this;

  const ALLOWED_MODES = {
    tag_setup_unfinished: 0,
    no_first_campaign: 1,
    no_active_campaigns: 2,
    setup_done_active_campaign: 3,
  };


  vm.$onInit = () => {
    Campaign.all({projectId: vm.project.id})
      .then(campaigns => {
        vm.campaigns = campaigns;
        vm.widgets = getVisibleWidgets();
        // generate widgets dynamically to avoid doing any ng-switch non-DRY solution
        _.each(vm.widgets, widget => {
          const maxHeight = widget.maxHeight || '500px';
          const template = `
          <div class="widget-base col-md-${widget.colWidth} ${widget.widgetName}-wrapper">
            <div
              class="widget-inner ${widget.widgetName}"
              ng-class="{
                shadow: ${widget.useShadow},
              }"
              style="max-height: ${maxHeight}">
              <zcs-dashboard-widget-${widget.widgetName}>
              </zcs-dashboard-widget-${widget.widgetName}>
            </div>
          </div>
        `;
          $element.find('.widget-list').append($compile(template)($scope));

        });

      });
  };

  function getVisibleWidgets() {
    let modeToBeEnabled;
    const activeCampaigns = sift(Campaign.activeFilters(), vm.campaigns);
    const isHideCharts = ['color_me_shop', 'shopify'].includes(vm.project.integrated_with) || vm.project.fixed_invoice_amount;

    if(!vm.project.tracking_tag_confirmed_at || !vm.project.conversion_tag_confirmed_at) {
      modeToBeEnabled = ALLOWED_MODES.tag_setup_unfinished;
    } else if(vm.campaigns.length === 0) {
      modeToBeEnabled = ALLOWED_MODES.no_first_campaign;
    } else if(activeCampaigns.length === 0) {
      modeToBeEnabled = ALLOWED_MODES.no_active_campaigns;
    } else if(activeCampaigns.length > 0) {
      modeToBeEnabled = ALLOWED_MODES.setup_done_active_campaign;
    }

    if(modeToBeEnabled === ALLOWED_MODES.setup_done_active_campaign) {
      return [
        ...isHideCharts ? {} : [
          {
            widgetName: 'site-status',
            colWidth: 8
          },
          {
            widgetName: 'realtime',
            colWidth: 4
          }
        ],
        {
          widgetName: 'campaign-list-title',
          colWidth: 12,
        },
        {
          widgetName: 'campaign-list',
          colWidth: 12,
        },
      ];
    } else if(modeToBeEnabled === ALLOWED_MODES.no_active_campaigns) {
      return [
        ...isHideCharts ? {} : [
          {
            widgetName: 'site-status',
            colWidth: 8
          },
          {
            widgetName: 'realtime',
            colWidth: 4
          }
        ],
        {
          widgetName: 'no-active-campaign',
          colWidth: 12,
          useShadow: true,
        },
      ];
    } else if(modeToBeEnabled === ALLOWED_MODES.no_first_campaign) {
      return [
        {
          widgetName: 'create-first-campaign',
          colWidth: 8.0
        },
        ...isHideCharts ? {} : [
          {
            widgetName: 'realtime',
            colWidth: 4
          }
        ],
      ];
    } else if(modeToBeEnabled === ALLOWED_MODES.tag_setup_unfinished) {
      return [
        {
          widgetName: 'tag-setup',
          colWidth: 12,
          maxHeight: 'none',
          useShadow: true,
        },
      ];
    }

    return [];
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/dashboard-main.component.js